import { render, staticRenderFns } from "./Publicar.vue?vue&type=template&id=362822d4&scoped=true"
import script from "./Publicar.vue?vue&type=script&lang=js"
export * from "./Publicar.vue?vue&type=script&lang=js"
import style0 from "./Publicar.vue?vue&type=style&index=0&id=362822d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362822d4",
  null
  
)

export default component.exports